import { render, staticRenderFns } from "./prizeCenter.vue?vue&type=template&id=76029268&scoped=true"
import script from "./prizeCenter.vue?vue&type=script&lang=js"
export * from "./prizeCenter.vue?vue&type=script&lang=js"
import style0 from "./prizeCenter.vue?vue&type=style&index=0&id=76029268&prod&scoped=true&lang=scss"
import style1 from "./prizeCenter.vue?vue&type=style&index=1&id=76029268&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76029268",
  null
  
)

export default component.exports